<script setup lang="ts">
import { useSiteStore } from '~/stores/site.store';
import type { ILanguage } from '~/interfaces/dto/general/language';
import Button from '../design-system/button.vue';
const runtimeConfig = useRuntimeConfig();
const { $trackEvent } = useNuxtApp();
const localeUtils = useLocaleUtils();

const settings = useSiteStore();

const languages = computed<ILanguage[]>(() =>
  settings.getConfig?.cultures
    ? settings.getConfig?.cultures
    : settings.getConfig?.Cultures || [],
);

const currentLocale = computed(
  () => (localeCode: string) =>
    languages.value.find((l) => l.cultureCode === localeCode),
);

function changeLocale(locale: string) {
  $trackEvent('NavigationEvent', 'SWITCH_LANGUAGE', {
    to: currentLocale?.value(locale)?.translation
  })
  switch (runtimeConfig.public.environment) {
    case 'production':
      const lang = currentLocale.value(locale);
      document.location.host = lang.url;
      break;
    default:
      localeUtils.changeLocale(locale);
  }
}
</script>

<template>
  <div v-if="languages.length > 1" class="w-full flex gap-2">
    <Button
      v-for="(lang, index) in languages"
      :key="index"
      :type="
        localeUtils.getLocale() === lang.cultureCode ? 'tertiary' : 'secondary'
      "
      padding="md"
      rounding="lg"
      :class="[
        'w-full flex-center font-normal',
        { 'std-border': localeUtils.getLocale() === lang.cultureCode },
      ]"
      @click="changeLocale(lang.cultureCode)"
    >
      {{ lang.translation }}
    </Button>
  </div>
</template>

<style scoped lang="scss"></style>
